import { useEffect, useState } from "react";
import { AddCanvasModal, DeleteCanvasModal, UpdateCanvasModal } from "../modal";
import { useRecoilState } from "recoil";
import { ModalTypeState } from "../../atoms";
import { GetNewInstance } from "../../helpers/HttpCommon";
import { CanvasListDto, CanvasesClient } from "../../services";
import { CanvasListItem } from "./CanvasListItem";
import { Pagination } from "../layouts";
import { Store } from "../../helpers";

export function CanvasList() {
  const [canvases, setCanvases] = useState<CanvasListDto[]>([]);
  const [, setModalType] = useRecoilState(ModalTypeState);

  const [totalPageNumber, setTotalPageNumber] = useState(1);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);

  const currentCustomer = Store.getCurrentCustomer();
  const client = new CanvasesClient(undefined, GetNewInstance());

  useEffect(() => {
    retrieveCanvases();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPageNumber]);

  useEffect(() => {
    setCurrentPageNumber(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const retrieveCanvases = () => {
    currentCustomer?.id &&
      client
        .getCanvases(currentCustomer?.id, currentPageNumber)
        .then((response) => {
          response && response.data && setCanvases(response?.data);
          response &&
            response.pageNumber &&
            setCurrentPageNumber(response?.pageNumber);
          response &&
            response.pageCount &&
            setTotalPageNumber(response?.pageCount);
        })
        .catch((error) => {
          console.log(error);
        });
  };

  const onAddCanvasSuccess = () => {
    if (currentCustomer) {
      currentCustomer.canvasesCount = (currentCustomer?.canvasesCount ?? 0) + 1;
      Store.setCurrentCustomer(currentCustomer);
    }
    retrieveCanvases();
    setModalType(null);
  };

  const onEditCanvasSuccess = () => {
    retrieveCanvases();
    setModalType(null);
  };

  const onDeleteCanvasSuccess = () => {
    if (currentCustomer && currentCustomer.canvasesCount) {
      currentCustomer.canvasesCount--;
      Store.setCurrentCustomer(currentCustomer);
    }
    retrieveCanvases();
    setModalType(null);
  };

  const onFailure = () => {
    setModalType(null);
  };

  return (
    <>
      <div className="h-full overflow-auto scrollbar-thin scrollbar-thumb-gray-600 scrollbar-track-transparent ">
        <div className="border-0 rounded-lg border-page-border text-body_14">
          <table className="w-full text-sm">
            <thead className="text-gray-300">
              <tr className="border-b border-page-border">
                <td className="px-4 py-3">Site Num</td>
                <td className="px-4 py-3">Layer group</td>
                <td className="px-4 py-3">Canvas</td>
                <td className="px-4 py-3">IP address</td>
                <td className="px-4 py-3">Resolution</td>
                <td className="px-4 py-3"></td>
              </tr>
            </thead>
            <tbody className="text-gray-100 ">
              {canvases.map((x) => (
                <CanvasListItem key={x.id} canvas={x} />
              ))}
            </tbody>
          </table>
          <Pagination
            totalPageCount={totalPageNumber}
            currentPageNumber={currentPageNumber}
            setCurrentPageNumber={setCurrentPageNumber}
          />
        </div>
      </div>
      <AddCanvasModal
        onSuccess={onAddCanvasSuccess}
        onFailure={onFailure}
        canvases={canvases}
      />
      <UpdateCanvasModal
        onSuccess={onEditCanvasSuccess}
        onFailure={onFailure}
        canvases={canvases}
      />
      <DeleteCanvasModal
        onSuccess={onDeleteCanvasSuccess}
        onFailure={onFailure}
      />
    </>
  );
}
